// Índice de documentos de la categoría: Instagram
import conectar_instagram from './conectar-instagram.js';

const instagramDocs = [
  conectar_instagram,
];

export default instagramDocs;
